import { ProposalTier, TIER_ORDER, WizardContentType, WizardObjective } from "./types";

// Tiers are cumulative: 'better' includes every 'good' content type plus its
// own, 'best' includes everything. `tier` on a content type is the minimum
// tier whose package contains it.
export const tierContentTypes = (
    objective: WizardObjective | undefined,
    tier: ProposalTier,
): WizardContentType[] => {
    if (!objective) return [];
    const included = TIER_ORDER.slice(0, TIER_ORDER.indexOf(tier) + 1);
    return objective.content_types
        .filter((ct) => included.includes(ct.tier))
        .sort((a, b) => a.rank - b.rank);
};

export const TIER_COPY: Record<ProposalTier, { label: string; tagline: string }> = {
    good: {
        label: "Good",
        tagline: "The essentials — build trust and clarity for your product.",
    },
    better: {
        label: "Better",
        tagline: "Adds objection-handling so hesitant shoppers convert.",
    },
    best: {
        label: "Best",
        tagline: "The full mix — cover every stage of the shopper journey.",
    },
};
